import { discActionTypes } from '../actions/disc-action-types';
import { usbActionTypes} from "../actions/usb-action-types";
import { getMapFromIdObjectArray, updateObjectInArrayById } from '../../common/reducer-helpers.js';
import {infoPanelActionTypes} from '../../infoPanel/actions/infoPanel-action-types';
import {albumItemActionTypes} from "../../album-view/actions/album-item-action-types";
import {store} from "../../App"
const initialState = {
    discPackages: [],
    selectDiscPackages: new Map(),
    selectedDiscDetail: null,
    discPackagesIsCompleted: false,
    selectedDiscDetailIsCompleted:false,
	offset: 0,
	max: -1,
	isProcessing: false,
    amIFetching: false,
	errorMessage: null,
    discDescriptors: [],
    discWizard: {
        discPackageType: null,
        includeType: null,
        selectedMedia: [],
        selectedIndex: new Set(),
    },
    usbWizard: {
        clipType: "EVERYTHING",
        videoSourceType: null,
        driveFormat: "PC",
        includeType: null,
        selectedMedia: [],
        selectedIndex: new Set(),
        selectedStat: {
            hasPhotos: false,
            hasVideos: false
        }
    },
    count: 0,
    scrollPosition: 0,
    selectDiscScrollPosition: 0
};
function get_selected_asset_stat(include_type, selectedMedia){
    let albumList = store.getState().albumList.albums;
    const selectedAlbums = selectedMedia.map(it=>it.albumId);
    const selectedItems = selectedMedia.map(it=>it.items)
    if(include_type === "selected_media"){
        albumList = albumList.filter(it=>selectedAlbums.includes(it.id) )
    }
    let hasPhotos = false
    let hasVideos = false;
    for(let i=0;i<albumList.length;i++){
        hasPhotos = hasPhotos || albumList[i].stats.numPhotos > 0
        hasVideos = hasVideos || albumList[i].stats.numClips > 0
    }

    return {
        hasPhotos: hasPhotos,
        hasVideos: hasVideos
    }
}
function addSelectionToArray(selectedMedia, action) {
    if (action.albumItemId != null) {
        let found = false
        for (let i = 0; i < selectedMedia.length; i++) {
            if (selectedMedia[i].albumId === action.albumId) {
                selectedMedia[i].items.push({id: action.albumItemId, displayOrder: action.albumItemDisplayOrder})
                selectedMedia[i].items.sort((left, right) => left.displayOrder - right.displayOrder);
                found = true;
                break;
            }
        }
        if (!found) {
            selectedMedia.push({
                albumId: action.albumId,
                displayOrder: action.displayOrder,
                items: [{id: action.albumItemId, displayOrder: action.albumItemDisplayOrder}]
            });
            selectedMedia.sort((left, right) => left.displayOrder - right.displayOrder);
        }
    }else{
        selectedMedia.push({
            albumId: action.albumId,
            displayOrder: action.displayOrder,
            items: []
        })
        selectedMedia.sort((left, right) => left.displayOrder - right.displayOrder);
    }

}

function removeSelectionFromArray(selectedMedia, action) {
    if (action.albumItemId != null) {
        let found = false
        for (let i = 0; i < selectedMedia.length; i++) {
            if (selectedMedia[i].albumId === action.albumId) {
                for (let j = 0; j < selectedMedia[i].items.length; j++) {
                    if (selectedMedia[i].items[j].id === action.albumItemId) {
                        selectedMedia[i].items.splice(j, 1);
                        if (selectedMedia[i].items === 0) {
                            //last item
                            selectedMedia.splice(i, 1)
                        }
                        found = true;
                        break;
                    }
                }
            }
            if (found) {
                break;
            }
        }
    } else {
        for (let i = 0; i < selectedMedia.length; i++) {
            if (selectedMedia[i].albumId === action.albumId) {
                selectedMedia.splice(i, 1)
                break;
            }
        }
    }
}
function buildSelectedIndex(selectedMedia){
    const selectedIndex = new Set()
    for(let i=0;i<selectedMedia.length;i++){
        selectedIndex.add("" + selectedMedia[i].albumId)
        if(selectedMedia[i].items.length > 0) {
            //Album partially selected
            selectedIndex.add("" + selectedMedia[i].albumId+":partial")
        }
        for(let j=0;j<selectedMedia[i].items.length;j++){
            selectedIndex.add(""+selectedMedia[i].albumId+":"+selectedMedia[i].items[j].id)
        }
    }
    return selectedIndex;
}
export const disc = (state = initialState, action) => {
    switch (action.type) {
        case discActionTypes.DISC_SCROLL:
            return {...state, scrollPosition: action.scrollPosition}
        case discActionTypes.DISC_ITEM_SCROLL: {
            return {...state, selectDiscScrollPosition: action.scrollPosition}
        }
        case discActionTypes.DISCS_REQUESTED:
            return {...state,amIFetching: true}
        case discActionTypes.DISCS_RECEIVED:
            let discArray = [];
            if(state.discPackages.length !== action.count){
                discArray = new Array(action.count);
                for(let i=0;i<action.count;i++){

                    discArray[i] = {
                        isLoaded:false,
                        displayOrder:i,
                        finalizedYn: "?"
                    }
                    if(typeof(action.ids) != "undefined" && action.ids.length === action.count){
                        discArray[i].id = action.ids[i];
                    }
                }
            }else{
                discArray = state.discPackages.slice(0);
            }
            for(let i=0; i< action.discs.length; i++){
                discArray[i+action.offsetStart] = action.discs[i];
                discArray[i+action.offsetStart].isLoaded = true;
            }
            return {
                ...state,
                discPackages: discArray,
                discPackagesIsCompleted: action.isComplete,
                count: action.count,
                offset: action.offset,
                amIFetching: false,
                selectDiscScrollPosition:0
            };
        case discActionTypes.DISCS_RECEIVED_FOR_SELECT:
            alert("Should not be used")
            return {
                ...state,
                selectDiscPackages: new Map([...state.selectDiscPackages.entries(), ...getMapFromIdObjectArray(action.discs).entries()])
        };
		case discActionTypes.DISCS_REQUEST_FAILED:
			return { ...state, isProcessing: false, errorMessage: action.errorMessage}
		case discActionTypes.CREATE_DISC_REQUEST:
			return { ...state, isProcessing: true, discUpdated: null}
		case discActionTypes.CREATE_DISC_SUCCESS:{
			let discArray = state.discPackages.slice(0);
            let workingDisc = null;
            let workingDiscIndex = -1;
            for(let i=0;i<discArray.length;i++){
                if(discArray[i].id === action.element.id){
                    workingDisc = discArray[i];
                    workingDiscIndex = i;
                    break;
                }
            }
            if(workingDisc == null) {
                workingDisc = action.element;
                workingDisc.numItems = 0; //numItems does not come back by default
                if(workingDisc.discPackageType == null) {
                    workingDisc.discPackageType = action.element.model.substring(8)
                }
            }else{
                workingDisc.caseTitle= action.element.caseTitle;
                workingDisc.caseSubtitle= action.element.caseSubtitle;
                workingDisc.caseSpineTitle= action.element.caseSpineTitle;
            }
            if(workingDiscIndex === -1){
                discArray.push(workingDisc)
            }
            return {...state, discPackages: discArray,isProcessing:false,saveSuccessful:true,discUpdated: workingDisc}

        }
		case discActionTypes.CREATE_DISC_FAILED:
			return { ...state, isProcessing:false, saveSuccessful: false, errorMessage: action.error.errorMessage}
		case discActionTypes.DELETE_DISC_SUCCESS:
			let discPackages = state.discPackages.filter(item => item.id !== action.discId)
			return { ...state, isProcessing:false, saveSuccessful: true, errorMessage: null,discPackages: discPackages}
        case discActionTypes.DELETE_DISC_FAILED:
            return { ...state, isProcessing: false, errorMessage: action.errorMessage}
        case discActionTypes.FINALIZE_DISC_REQUEST:
            return { ...state, isProcessing: true}
        case discActionTypes.FINALIZE_DISC_SUCCESS: {
            let newState = {...state}
            newState.discPackages = state.discPackages.slice(0);
            for(let i=0;i<newState.discPackages.length;i++){
                if(newState.discPackages[i].id === action.element.id){
                    newState.savedDisc = newState.discPackages[i];
                    break
                }
            }
            newState.isProcessing = false;
            newState.saveSuccessful = true;
            return newState;
        }

        
        case discActionTypes.DISC_ITEM_ROTATE_SUCCESS:{
          
           
            const discitems = state.selectedDiscDetail.chapters;

            const newDiscPackages = state.selectedDiscDetail;
           
            newDiscPackages.chapters = discitems.map(item => 
                { if (item.id === action.id){
                        item.rotation = action.rotation; 

                    }
                    return item;});



            return { ...state,
                selectedDiscDetail: newDiscPackages
                
                };
            }
        case discActionTypes.FINALIZE_DISC_FAILED:
            return { ...state, isProcessing: false, errorMessage: action.errorMessage}
        case discActionTypes.ADD_TO_DISC_REQUEST:
            return {...state, isProcessing:true}
        case discActionTypes.ADD_DISC_TO_DISC_SUCCESS:{
            const discs = [...state.discPackages]
            for(let i=0;i<discs.length;i++){
                if(discs[i].id == action.element.discId){
                    discs[i] = action.element.disc;
                    break;
                }
            }
            return {...state, discPackages: discs}
        }
        case discActionTypes.ADD_TO_DISC_SUCCESS:{
            console.log("ADD_TO_DISC_SUCCESS.  state.isProcessing: " + state.isProcessing+" chapters.length:"+action.element.chapters.length)
            let newState = {...state,isProcessing:false,saveSuccessful:true}
            newState.discPackages = state.discPackages.slice(0);
            let thisDisc = null;
            for(let i=0;i<newState.discPackages.length;i++){
                if(newState.discPackages[i].id === action.element.discId){
                    thisDisc = newState.discPackages[i];
                    break;
                }
            }
            if(thisDisc == null){
                return newState;
            }
            for(let i=0;i<action.element.chapters.length;i++){
                thisDisc.thumbnails.push(action.element.chapters[i].thumbnail)
            }
            newState.savedDisc = thisDisc;
            return newState;
        }
        case discActionTypes.CLEAR_DISC_ITEMS:
            return {...state, selectedDiscDetail: null}
        case discActionTypes.ADD_TO_DISC_FAILED:
            return {...state, isProcessing:false,errorMessage: action.element.errorMessage,saveSuccessful:false}
        case discActionTypes.FETCH_DISC_REQUEST:
            return {...state, isProcessing:true}
        case discActionTypes.FETCH_DISC_SUCCESS: {
            let existingDisc = null;
            if(state.selectedDiscDetail == null || state.selectedDiscDetail.id !== action.discId) {
                for (let i = 0; i < state.discPackages.length; i++) {
                    if (state.discPackages[i].id === action.discId) {
                        existingDisc = {...state.discPackages[i]};
                        break;
                    }
                }
            }else{
                existingDisc = {...state.selectedDiscDetail}
            }
            if (existingDisc == null) {
                existingDisc = {
                    id: action.discId,
                    discPackageType: action.discPackageType,

                }
            }
            let discArray = [];
            if (typeof(existingDisc.chapters) === "undefined" || existingDisc.chapters.length !== action.count) {
                discArray = new Array(action.count);
                for (let i = 0; i < action.count; i++) {

                    discArray[i] = {
                        isLoaded: false,
                        displayOrder: i,
                    }
                    if (action.ids.length === action.count) {
                        discArray[i].id = action.ids[i];
                    }
                }
            } else {
                discArray = existingDisc.chapters.slice(0);
            }
            for (let i = 0; i < action.chapters.length; i++) {
                discArray[i + action.offsetStart] = action.chapters[i];
                discArray[i + action.offsetStart].isLoaded = true;
            }
            existingDisc.stats = {
                offset: action.offset,
                max: action.max,
                count: action.count,
                isComplete: discArray.filter(chap=>chap.isLoaded === false).length === 0
            };
            existingDisc.chapters = discArray;
            return {
                ...state,
                isProcessing: false,
                selectedDiscDetail: existingDisc,
                selectedDiscDetailIsComplete: action.isComplete
            }
        }
        case discActionTypes.FETCH_DISC_FAILED:
            return {...state, isProcessing:false, errorMessage: action.errorMessage}
        case discActionTypes.SELECT_DISC_ITEM: {
            if(state.selectedDiscDetail == null){
                return state;
            }
            let chapters = state.selectedDiscDetail.chapters.map(item => (item.id === action.element.id ? {...item,selected:true} : item));
            return {
                ...state,
                selectedDiscDetail: {...state.selectedDiscDetail, chapters: chapters}
            };
        }
        case discActionTypes.DESELECT_DISC_ITEM: {
            let chapters = state.selectedDiscDetail.chapters.map(item => (item.id === action.element.id ? {...item,selected:false} : item));
            return {
                ...state,
                selectedDiscDetail: {...state.selectedDiscDetail, chapters: chapters}
            };
        }
        case discActionTypes.CLEAR_SELECTED_DISC_ITEMS: {
            if(state.selectedDiscDetail == null){
                return state;
            }
            let chapters = state.selectedDiscDetail.chapters.map(item => (item.selected === true ? {...item, selected:false}:item));
            return {
                ...state,
                selectedDiscDetail: {...state.selectedDiscDetail, chapters: chapters}
            };
        }
        case discActionTypes.ENABLE_DISC_ITEM_SELECTION_MODE:
            return {
                ...state, itemSelectionModeEnabled: true
            }
        case discActionTypes.DISABLE_DISC_ITEM_SELECTION_MODE:
            return {
                ...state, itemSelectionModeEnabled: false
            }
        case discActionTypes.DELETE_SELECTED_ITEMS_REQUESTED:{
            return {
                ...state, isProcessing: true
            }
        }
        case discActionTypes.DELETE_SELECTED_ITEMS_SUCCESS:{
            let chapters = state.selectedDiscDetail.chapters.filter(item => item.selected !== true)
            const selectedDiscDetail={...state.selectedDiscDetail, chapters: chapters}
            if(state.selectedDiscDetail.discPackageType === "PhotoCdPackage") {
                let deletedBytes = state.selectedDiscDetail.chapters.filter(item => item.selected === true).map(item => item.fileSize).reduce((total, next) => total + next);
                selectedDiscDetail.usageInBytes = selectedDiscDetail.usageInBytes - deletedBytes;
            }else{
                let deletedDuration = state.selectedDiscDetail.chapters.filter(item => item.selected === true).map(item => item.timeCodes.duration).reduce((total, next) => total + next);
                selectedDiscDetail.duration = selectedDiscDetail.duration - deletedDuration;
            }
            return {
                ...state,
                isProcessing: false,
                selectedDiscDetail: selectedDiscDetail
            };
        }
        case discActionTypes.DELETE_SELECTED_ITEMS_FAILED:{
            return {
                ...state, isProcessing: false,errorMessage: action.element
            }
        }
        case discActionTypes.UPDATE_CHAPTER_SUCCESS:{

        }
        case discActionTypes.ENABLE_DISC_ITEM_ARRANGE_MODE:
            return {
                ...state, itemArrangeModeEnabled: true
            }
        case discActionTypes.DISABLE_DISC_ITEM_ARRANGE_MODE:
            return {
                ...state, itemArrangeModeEnabled: false
            }
        case discActionTypes.SET_DISC_ITEM_SORT:
        {
            let discState = Object.assign(state);

            return discState;

        }
        case discActionTypes.SAVE_DISC_ARRANGEMENT:{
            return state;
        }
        case discActionTypes.MOVE_DISC_ITEM_AFTER:{
            if(action.element.discItemId === action.element.moveAfterItemId){
                return state;
            }
            let chapters=[]
            for(let i=0;i<state.selectedDiscDetail.chapters.length;i++){
                chapters.push(state.selectedDiscDetail.chapters[i])
            }
            let moveItemIndex = -1
            let moveToItemIndex = -1;
            //moveAfterItemId
            for(let i=0;i<chapters.length;i++){
                if(chapters[i].id === action.element.discItemId){
                    moveItemIndex=i;
                }else if(chapters[i].id === action.element.moveAfterItemId){
                    moveToItemIndex = i;
                }
                if(moveItemIndex !== -1 && moveToItemIndex !== -1){
                    break;
                }
            }
            let originalSortOrder = chapters[moveToItemIndex].displayOrder;
            chapters[moveItemIndex].displayOrder = originalSortOrder;
            chapters[moveItemIndex].modified=true;
            if(moveItemIndex < moveToItemIndex){
                //i.e. #3 => #5
                for(let i=moveItemIndex+1;i<=moveToItemIndex;i++){
                    chapters[i].displayOrder = chapters[i].displayOrder - 1;
                    chapters[i].modified = true;
                }
            }else{
                for(let i=moveItemIndex-1;i>=moveToItemIndex;i--){
                    chapters[i].displayOrder = chapters[i].displayOrder + 1;
                    chapters[i].modified = true;
                }
            }

            chapters = chapters.sort((a,b) =>  (a.displayOrder-b.displayOrder))
            return {...state, selectedDiscDetail: {...state.selectedDiscDetail, chapters: chapters}}
        }
        case discActionTypes.SAVE_DISC_ARRANGEMENT_SUCCESS:{
            return state;
        }
        case discActionTypes.DISC_WIZARD_SET: {
            return {...state, discWizard: Object.assign({},state.discWizard, action.data)}
        }
        case discActionTypes.DISC_WIZARD_SELECT_MEDIA: {
            //Action looks like: {albumId: 123,displayOrder:0 albumItemId:123,albumItemDisplayOrder:0,toggleMode:"all|none|toggle"} where albumItemId can be absent or null
            //Stored data looks like [{albumId: 123,displayOrder:0,items:[{id:123,displayOrder:0]}]
            //If we didn't need to store the displayOrder, this all could be stored in the index much more efficiently
            //If they decide sortOrder is not required, refactor this to just store the index for efficiency
            const selectedMedia = state.discWizard.selectedMedia.slice(0);

            if(action.toggleMode === "all"){
                if(!state.discWizard.selectedIndex.has(""+action.albumId + (action.albumItemId != null ? (":"+action.albumItemId) : ""))) {
                    addSelectionToArray(selectedMedia, action);
                }
            }else if(action.toggleMode === "toggle"){
                if(!state.discWizard.selectedIndex.has(""+action.albumId + (action.albumItemId != null ? (":"+action.albumItemId) : ""))) {
                    addSelectionToArray(selectedMedia, action);
                }else{
                    removeSelectionFromArray(selectedMedia, action);
                }
            }else if(action.toggleMode === "none"){
                if(state.discWizard.selectedIndex.has(""+action.albumId + (action.albumItemId != null ? (":"+action.albumItemId) : ""))) {
                    removeSelectionFromArray(selectedMedia, action);
                }
            }
            const selectedIndex = buildSelectedIndex(selectedMedia);
            return {
                ...state,
                discWizard: {...state.discWizard,selectedMedia: selectedMedia,selectedIndex:selectedIndex}
            }
        }
        case discActionTypes.DISC_WIZARD_DATA_RECEIVED: {
            return {
                ...state,
                discDescriptors: action.data.results
            }
        }

        case infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_REQUEST_DISC: {

            const selectedDiscDetail={...state.selectedDiscDetail, chapters: updateObjectInArrayById(state.selectedDiscDetail.chapters,action.updateData,action.id)};
            return {
                ...state,

                selectedDiscDetail
            };
        }
        case discActionTypes.DISC_WIZARD_SAVE_SUCCESS: {
            return {
                ...state,
                discWizard: {
                    discPackageType: null,
                    includeType: null,
                    selectedMedia: [],
                    selectedIndex: new Set(),
                    previousDiscWizard: {...state.discWizard}
                }
            }
        }
        case discActionTypes.DISC_WIZARD_ROLLBACK_SAVED:{
            if(state.discWizard.previousDiscWizard != null){
                return {...state, discWizard: {...state.discWizard.previousDiscWizard}}
            }else{
                return state;
            }
        }
        
        case discActionTypes.DISC_WIZARD_SET_ROLLBACK_POINT: {
            let albumStatus = {albumId: action.albumId,wasSelected:false}
            for(let i=0;i<state.discWizard.selectedMedia.length;i++){
                if(state.discWizard.selectedMedia[i].albumId === action.albumId){
                    albumStatus = {albumId: state.discWizard.selectedMedia[i].albumId,
                        displayOrder: state.discWizard.selectedMedia[i].displayOrder,
                        items: [...state.discWizard.selectedMedia[i].items]};
                    break;
                }
            }
            return {...state, discWizard: {...state.discWizard, rollbackPoint: albumStatus}}
        }
        case discActionTypes.DISC_WIZARD_ROLLBACK: {
            let selectedMedia = state.discWizard.selectedMedia.slice();
            let albumIndex = -1;
            for(let i=0;i<selectedMedia.length;i++){
                if(selectedMedia[i].albumId === action.albumId){
                    albumIndex = i;
                    break;
                }
            }
            if(albumIndex != -1){
                if(state.discWizard.rollbackPoint != null){
                    if(state.discWizard.rollbackPoint.wasSelected === false){
                        selectedMedia.splice(albumIndex,1)
                    }else{
                        selectedMedia[albumIndex] = state.discWizard.rollbackPoint;
                    }
                }
            }
            const selectedIndex = buildSelectedIndex(selectedMedia);
            return {...state, discWizard: {...state.discWizard, selectedMedia: selectedMedia,selectedIndex: selectedIndex,rollbackPoint: null}}
        }
        case discActionTypes.CLEAR_DISC_PACKAGES:{
            return {...state, discPackages: [], offset:0, isComplete:false, discWizard: {
                    discPackageType: null,
                    includeType: null,
                    selectedMedia: [],
                    selectedIndex: new Set(),
                } }
        }
        case discActionTypes.DELETE_DISC_DISCRIPTOR_SUCCESS:{
            const discPackages = state.discPackages.filter(it => it.discDescriptorId != action.discDescriptorId)
            const discDescriptors = state.discDescriptors.filter(it => it.id != action.discDescriptorId)
            return {...state, discPackages: discPackages, discDescriptors: discDescriptors}
        }
        case usbActionTypes.USB_WIZARD_SET: {
            const newState = {...state, usbWizard: Object.assign({},state.usbWizard, action.data)}
            newState.usbWizard.selectedStat = get_selected_asset_stat(newState.usbWizard.includeType,newState.usbWizard.selectedMedia);
            return newState
        }
        case usbActionTypes.USB_WIZARD_SELECT_MEDIA: {
            //Action looks like: {albumId: 123,displayOrder:0 albumItemId:123,albumItemDisplayOrder:0,toggleMode:"all|none|toggle"} where albumItemId can be absent or null
            //Stored data looks like [{albumId: 123,displayOrder:0,items:[{id:123,displayOrder:0]}]
            //If we didn't need to store the displayOrder, this all could be stored in the index much more efficiently
            //If they decide sortOrder is not required, refactor this to just store the index for efficiency
            const selectedMedia = state.usbWizard.selectedMedia.slice(0) || [];
            if(action.toggleMode === "all"){
                if(!state.usbWizard.selectedIndex.has(""+action.albumId + (action.albumItemId != null ? (":"+action.albumItemId) : ""))) {
                    addSelectionToArray(selectedMedia, action);
                }
            }else if(action.toggleMode === "toggle"){
                if(!state.usbWizard.selectedIndex.has(""+action.albumId + (action.albumItemId != null ? (":"+action.albumItemId) : ""))) {
                    addSelectionToArray(selectedMedia, action);
                }else{
                    removeSelectionFromArray(selectedMedia, action);
                }
            }else if(action.toggleMode === "none"){
                if(state.usbWizard.selectedIndex.has(""+action.albumId + (action.albumItemId != null ? (":"+action.albumItemId) : ""))) {
                    removeSelectionFromArray(selectedMedia, action);
                }
            }
            const selectedIndex = buildSelectedIndex(selectedMedia);
            const selectedStat = get_selected_asset_stat(state.usbWizard.includeType,selectedMedia)
            return {
                ...state,
                usbWizard: {...state.usbWizard,selectedMedia: selectedMedia,selectedIndex:selectedIndex, selectedStat: selectedStat}
            }
        }
        case usbActionTypes.USB_WIZARD_ROLLBACK_SAVED:{
            if(state.usbWizard.previousDiscWizard != null){
                return {...state, usbWizard: {...state.usbWizard.previousDiscWizard}}
            }else{
                return state;
            }
        }

        case usbActionTypes.USB_WIZARD_SET_ROLLBACK_POINT: {
            let albumStatus = {albumId: action.albumId,wasSelected:false}
            for(let i=0;i<state.usbWizard.selectedMedia.length;i++){
                if(state.usbWizard.selectedMedia[i].albumId === action.albumId){
                    albumStatus = {albumId: state.usbWizard.selectedMedia[i].albumId,
                                   displayOrder: state.usbWizard.selectedMedia[i].displayOrder,
                                   items: [...state.usbWizard.selectedMedia[i].items]};
                    break;
                }
            }
            return {...state, usbWizard: {...state.usbWizard, rollbackPoint: albumStatus}}
        }
        case usbActionTypes.USB_WIZARD_ROLLBACK: {
            let selectedMedia = state.usbWizard.selectedMedia.slice();
            let albumIndex = -1;
            for(let i=0;i<selectedMedia.length;i++){
                if(selectedMedia[i].albumId === action.albumId){
                    albumIndex = i;
                    break;
                }
            }
            if(albumIndex != -1){
                if(state.usbWizard.rollbackPoint != null){
                    if(state.usbWizard.rollbackPoint.wasSelected === false){
                        selectedMedia.splice(albumIndex,1)
                    }else{
                        selectedMedia[albumIndex] = state.usbWizard.rollbackPoint;
                    }
                }
            }
            const selectedIndex = buildSelectedIndex(selectedMedia);
            return {...state, usbWizard: {...state.usbWizard, selectedMedia: selectedMedia,selectedIndex: selectedIndex,rollbackPoint: null}}
        }
        default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/disc/reducers/disc-reducers.js